import ZccInstallationRow from './components/ZccInstallationRow/themes/ZccInstallationRowLight.css';
import ZccNotification from './components/ZccNotification/themes/ZccNotificationLight.css';

export default {
  ZccInstallationRow,
  ZccNotification,
};
